import { render, staticRenderFns } from "./AppTagEntityForm.vue?vue&type=template&id=23ceb459&scoped=true&"
import script from "./AppTagEntityForm.vue?vue&type=script&lang=js&"
export * from "./AppTagEntityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ceb459",
  null
  
)

export default component.exports